module.exports = __webpack_public_path__ + "static/media/challenge-2.63d5526d.png";